import Vue from 'vue';
import VueResource from 'vue-resource';
import Vuelidate from 'vuelidate';
import PhoneCode from '../../components/forms/component.phone-code.vue';
import OfficeHours from '../../section-specific/applications/mixins/office-hours';

import {
    required,
    email
} from 'vuelidate/lib/validators';


import { Spinner } from 'spin.js';

Vue.use(Vuelidate);
Vue.use(VueResource);

import MainVue from '../../main-vue-bn';

function requiredIfOther(val) {
    if (this.form.queryType === 'Other') {
        return val !== '';
    } else {
        return true;
    }
}

const ibSpinOpts = {
    lines: 7 // The number of lines to draw
    , length: 21 // The length of each line
    , width: 6 // The line thickness
    , radius: 15 // The radius of the inner circle
    , scale: 0.3 // Scales overall size of the spinner
    , corners: 1 // Corner roundness (0..1)
    , color: '#fff' // #rgb or #rrggbb or array of colors
    , opacity: 0.45 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.4 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '50%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: true // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

function onlyAlphaNumeric(val) {
    var re = /^[\x00-\x7F]+$/;
    try {
        if (val) {
            val = val.toString();
            return re.test(val.toLowerCase()) && /^([^'<>]+)$/.test(val.toLowerCase());
        } else {
            return true;
        }
    } catch (e) {
        console.log(e);
    }
}

//removed apostrophe
function onlyAlphaNumericWithApst(val) {
    var re = /^[\x00-\x7F]+$/;
    // SENTRY-912
    if(val && typeof val === 'string'){
      return re.test(val.toLowerCase()) && /^([^<>]+)$/.test(val.toLowerCase());
    }
    else{
      return true;
    }
  }

function nameRegexValidationIMG(x){
  let r =  new RegExp ("^[a-zA-Z ()\\-\\ '/.,ÀÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]+$");
  return r.test(x);
}

function isChromeBrowser() {
    const userAgentBrow = window.navigator.userAgent;
    return userAgentBrow.indexOf("Chrome") != -1;
}

function getBrokerNexusApiHost() {
    if (location.hostname === 'bknexustest.insubuytest.com') {
        return 'bknexustest.insubuytest.com';
    }
    if (location.hostname === 'brokersnexusdev') {
        return 'brokersnexusdev';
    }
    return 'sample.brokersnexus.com';
}

new MainVue({
    el: '#bn-app',
    mixins: [OfficeHours],
    components: {
        'phone-code': PhoneCode
    },
    data: function () {
        return {
            formSending: false,
            formSent: false,
            emailSending: false,
            emailSent: false,
            showMobileError: false,
            form: {
                firstName: '',
                lastName: '',
                companyName: '',
                addressStreet1: '',
                addressStreet2: '',
                city: '',
                usState: '',
                postalCode: '',
                country: '',
                phone: '',
                fax: '',
                email: '',
                bestReachTime: '',
                websiteAddr: '',
                queryType: this.getParameterByName('queryType') != null ? this.getParameterByName('queryType') : '',
                queryTypeDetail: '',
                purpose: this.getParameterByName('purpose') != null ? this.getParameterByName('purpose') : '',
                comments: '',
                verificationCodeUser: ''
            },
            contactFormSSErrors: {
                fieldErrors: [],
                globalErrors: []
            },
            showIntro: false,
            showContact: false,
            headerLogo: "assets/svg/brokersnexus_logo.svg",
            hideAutofill: false,
            isChrome: isChromeBrowser(),
            countrySelected:'USA',
            countries: bnJS.countries,
            timefetched: false,
            disableSendBtn: true
        }
    },
    validations: {
        form: {
            firstName: {
                required,
                nameRegexValidationIMG
            },
            lastName: {
                required,
                nameRegexValidationIMG
            },
            companyName: {
                onlyAlphaNumeric
            },
            addressStreet1: {
                onlyAlphaNumeric
            },
            addressStreet2: {
                onlyAlphaNumeric
            },
            country: {
                required
            },
            city: {
                onlyAlphaNumeric
            },
            state: {
                onlyAlphaNumeric
            },
            postalCode: {
                onlyAlphaNumeric
            },
            phone: {
                onlyAlphaNumeric
            },
            fax: {
                onlyAlphaNumeric
            },
            email: {
                required,
                onlyAlphaNumeric,
                validEmail: email
            },
            websiteAddr: {
                onlyAlphaNumeric
            },
            bestReachTime: {
                onlyAlphaNumeric
            },
            queryType: {
                required
            },
            queryTypeDetail: {
                requiredIfOther,
                onlyAlphaNumeric
            },
            comments: {
                required,
                onlyAlphaNumericWithApst
            },
        }
    },
    computed: {
        emailFormShownC: function () {
            if (this.emailSent) {
                return false;
            } else {
                return true;
            }
        },
        isSelectedUSA: function () {
            return this.form.country == 'United States';
        }
    },
    mounted: function () {
        var $dataHidden = document.querySelectorAll("[data-hide]");
        for (var i = 0, hLength = $dataHidden.length; i < hLength; i++) {
            $dataHidden[i].removeAttribute("data-hide");
        }
        Vue.nextTick(() => {
            this.hideAutofill = true;
        })
        if (!this.timefetched) {
            this.getCurrentCSTTime();
            this.timefetched = true;
        }

        var self = this;
        window.handleSuccess = function (token) {
            self.disableSendBtn = false;
            self.form.verificationCodeUser = token;
            console.log('cloudflare ' + token);
        };

        window.handleError = function (error) {
            console.log('turnstile error' + error);
        };

        const waitForTurnstile = () => {
            self.$http.get('https://' + getBrokerNexusApiHost() + '/api/turnstile-token/').then(response => {
                const responseBody = response.body;
                if (responseBody && responseBody.token) {
                    if (window.turnstile && window.turnstile.render) {
                        console.log("Turnstile loaded");
                        window.turnstile.render("#cf-turnstile", {
                            sitekey: responseBody.token,
                            theme: "light",
                            size: "normal",
                            callback: window.handleSuccess,
                            "error-callback": window.handleError
                        });
                    } else {
                        console.log("Waiting for Turnstile...");
                        setTimeout(waitForTurnstile, 200);
                    }
                } else {
                    console.log('turnstile token not found', responseBody);
                }
            }).catch(error => {
                console.log('turnstile token error', error);
            });
        };

        this.$nextTick(waitForTurnstile);
    },
    created: function () {
        console.log('contact-us created');
    },
    methods: {
        sendEmail: function () {
            var self = this;
            var data = self.form;

            self.contactFormSSErrors.globalErrors = [];
            self.contactFormSSErrors.fieldErrors = [];
            this.$v.$touch();

            if (!self.$v.$invalid) {

                var spinTarget = self.$refs.btnspinner;
                var spinOpts = ibSpinOpts;

                var spinner = new Spinner(spinOpts).spin(spinTarget);
                self.formSending = true;
                data.fromBN = "true";

                let requestURL = getBrokerNexusApiHost();

                self.$http.post('https://' + requestURL + '/api/contact-us/email/?lang=en', data)
                    .then(
                        function (response) {
                            var responseBody = response.body;

                            if (responseBody.status === 'error') {
                                self.formSending = false;

                                self.resetCaptcha();

                                if (responseBody.data.globalErrors) {
                                    self.contactFormSSErrors.globalErrors = responseBody.data.globalErrors;
                                }
                                if (responseBody.data.fieldErrors) {
                                    self.contactFormSSErrors.fieldErrors = responseBody.data.fieldErrors;
                                }

                                // Animate scroll to top for ss errors
                                $('html, body').animate({
                                    scrollTop: $("#js-Contact-form-response").offset().top
                                }, 'fast');
                            } else {
                                //Email sent successfully
                                self.formSending = false;

                                self.formSent = true;
                                self.emailSent = true;

                                self.contactFormSSErrors.globalErrors = [];
                                self.contactFormSSErrors.fieldErrors = [];
                                self.resetCaptcha();
                                $('html, body').animate({
                                    scrollTop: $("#js-Contact-form-response").offset().top
                                }, 'fast');
                            }

                        },
                        function (response) {
                            self.formSending = false;
                            console.log('Houston, we have a problem sending email.');
                        });
            } else {
                setTimeout(() => {
                    $('html, body').animate({
                        scrollTop: $(".o-Valid-msg.inValid").first().offset().top - 100
                    }, 'fast');
                }, 200);
            }

        },
        resetForm: function () {
            this.form.firstName = "";
            this.form.lastName = "";
            this.form.companyName = "";
            this.form.addressStreet1 = "";
            this.form.addressStreet2 = "";
            this.form.city = "";
            this.form.usState = "";
            this.form.postalCode = "";
            this.form.country = "";
            this.form.phone = "";
            this.form.fax = "";
            this.form.email = "";
            this.form.bestReachTime = "";
            this.form.websiteAddr = "";
            this.form.queryType = "";
            this.form.queryTypeDetail = "";
            this.form.purpose = "";
            this.form.comments = "";
            this.form.verificationCodeUser = "";

            this.resetCaptcha();
            this.$v.$reset();
        },
        resetCaptcha: function () {
            this.form.verificationCodeUser = '';
            this.disableSendBtn = true;
            if (window.turnstile && window.turnstile.reset) {
                window.turnstile.reset("#cf-turnstile");
            }
        },
        getParameterByName(name) {
            return decodeURIComponent((new RegExp('[?|&]' +
                            name + '=' + '([^&;]+?)(&|#|;|$)')
                        .exec(location.search) || [, ""])[1]
                    .replace(/\+/g, '%20')) ||
                null;
        },
        clearState: function (e) {
            this.countrySelected = $(e.target.options[e.target.options.selectedIndex]).attr("data-country-code");
            this.form.state = '';
            this.form.usState = '';
            if (this.countrySelected !== 'USA') {
                this.$refs.stateInfo.value = '';
            }
        },
    }
});
